import { Injectable } from '@angular/core';

@Injectable()
export class PasswordPolicyService {

  constructor() { }

  getDefaultPasswordPolicy() {
    return {
      lowerCase: 1,
      upperCase: 1,
      numberOfDigits: 1,
      length: 8,
    };
  }
}
